import { Injectable, Injector } from '@angular/core';
import { BitfApiService } from '@bitf/services/api/bitf-api.service';

@Injectable({
  providedIn: 'root',
})
export class LogSender extends BitfApiService {
  constructor(protected injector: Injector) {
    super('error-logs', injector);
  }
}
